// Section 1
import { Injectable } from '@angular/core'
import { Action } from '@ngrx/store'
import { DocCategories2CIF } from '../../shared/viewmodels/UtilityObj';


// Section 2
export const ADD_DOCCATEGORIES2 = '[DOCCATEGORIES2] Add'
export const REMOVE_DOCCATEGORIES2 = '[DOCCATEGORIES2] Remove'

// Section 3
export class AddDocCategories2 implements Action {
  readonly type = ADD_DOCCATEGORIES2

  constructor(public payload: DocCategories2CIF) { }
}

export class RemoveDocCategories2 implements Action {
  readonly type = REMOVE_DOCCATEGORIES2

  constructor(public payload: number) { }
}

// Section 4
export type DocCategories2Actions = AddDocCategories2 | RemoveDocCategories2

